import {Navigate, Outlet, useLocation} from 'react-router-dom';

const RequireAuth = () => {
    let location = useLocation();
    const token = sessionStorage.getItem('token');
    if (!token) {
        return <Navigate to="/login" state={{from: location}} replace/>;
    }
    const user = JSON.parse(sessionStorage.getItem('user'));
    const path = location.pathname.split('/')[1];
    if (user.type !== '1' && path === 'user') {
        return <Navigate to="/page403" state={{from: location}} replace/>;
    }

    return <Outlet/>
}

export default RequireAuth;